import { useOrganizationRole } from '@/hooks/useOrganizationRole';
import { useSubscription } from '@/hooks/useSubscription';

const isSubscribedStatus = (status?: string) => {
  return status === 'active' || status === 'trialing';
};

export const useAccessPermissions = () => {
  const { subscription, isLoading: isSubscriptionLoading } = useSubscription();
  const { isOrgLoaded, isOrgActive, hasOrgMembership, isOrgAdmin } =
    useOrganizationRole();

  const isOrganizationLoading = !isOrgLoaded;
  const isLoading = isSubscriptionLoading || isOrganizationLoading;

  const hasSubscription = !isSubscriptionLoading && !!subscription;
  const isSubscribed = subscription
    ? isSubscribedStatus(subscription.status)
    : false;
  const hasActiveSubscription = hasSubscription && isSubscribed;

  const hasOrganizationMembership = isOrgActive && hasOrgMembership;
  const isOrganizationAdmin = isOrgAdmin;

  const isAccessDenied = !hasActiveSubscription && !hasOrganizationMembership;

  return {
    isLoading,
    isSubscriptionLoading,
    isOrganizationLoading,
    hasSubscription,
    hasActiveSubscription,
    hasOrganizationMembership,
    isOrganizationAdmin,
    isAccessDenied,
  };
};
